export default __webpack_public_path__ + "static/media/articalFrst.31e1920b.webp";